export default "__VITE_ASSET__BQdT4JYq__"